<template>
  <base-view edition="2026" />
</template>

<script>
import BaseView from "@/views/BaseView";

export default {
  components: {
    BaseView,
  },
};
</script>
